import {
  Box,
  Container,
  Text,
  Heading,
  VStack,
  List,
  ListItem,
} from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import { useEffect } from "react";

const GiveawayTermsAndPrivacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box py={8}>
      <Helmet>
        <title>
          Terms of Use and Privacy Policy for Giveaway | BulletScout
        </title>
        <meta
          name="description"
          content="Official Rules, Terms, & Conditions BulletScout.com Free Ammo for Life Giveaway"
        />
      </Helmet>

      <Container maxW="4xl" pt={"50px"}>
        <VStack spacing={8} align="stretch">
          <Heading as="h1" size="xl" textAlign="center">
            Official Rules, Terms, & Conditions BulletScout.com Free Ammo for
            Life Giveaway
          </Heading>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              1. Eligibility
            </Heading>
            <Text>
              The BulletScout.com Free Ammo for Life Giveaway (the "Giveaway")
              is offered, sponsored, and conducted by Quick Take Retail, LLC
              (“BulletScout”) and is open to individuals who meet all of the
              following conditions:
            </Text>
            <List as="ol" styleType="lower-alpha" pl={8} spacing={2}>
              <ListItem>
                Are legal residents of the continental United States;
              </ListItem>
              <ListItem>
                At the time of Giveaway entry are at least 21 years of age or
                older (or the legal age required to purchase the ammunition
                constituting the Prize in their state of residence) at the time
                of entry;
              </ListItem>
              <ListItem>
                Legally permitted under federal, state, and local laws to
                purchase, receive custody and ownership of, and use the
                ammunition constituting the Prize.
              </ListItem>
            </List>
            <Text>
              Employees, officers, and directors of BulletScout, as well as
              their immediate family and household members, are not eligible to
              participate in the Giveaway.
            </Text>
          </VStack>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              2. Entry Period
            </Heading>
            <Text>
              The Giveaway begins on the launch date of BulletScout.com and ends
              at 11:59 PM (CST) on October 31, 2025 (the "Entry Period").
              Entries submitted after the Entry Period ends will not be
              considered.
            </Text>
          </VStack>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              3. How to Enter
            </Heading>
            <Text>
              No purchase is necessary to enter the Giveaway or to win the
              Prize.
            </Text>
            <Text>
              Each participant is allowed one (1) entry into the Giveaway by
              submitting their email address on the www.BulletScout.com website
              (“BulletScout.com” or the “Site”). Each participant may also
              receive additional entries into the Giveaway by completing various
              tasks as specified on BulletScout.com. Tasks may include, but are
              not limited to, social media sharing, referrals, or other
              promotional activities. Methods of additional entry and their
              corresponding values will be outlined on BulletScout.com.
            </Text>
            <Text>
              All entries must be received by the end of the Entry Period.
            </Text>
          </VStack>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              4. Prize Details & Availability
            </Heading>
            <Text>One (1) winner will receive the following Prize:</Text>
            <Text pl={4}>
              One (1) case of 9 mm pistol ammunition per year for eighty (80)
              years (the “Prize”).
            </Text>
            <Text>
              The brand, grain, case quantity, and specific SKU of ammunition
              which will constitute the Prize shall be determined at
              BulletScout’s sole discretion. BulletScout shall endeavour to
              provide the same brand, grain, and SKU of ammunition over the
              course of the lifetime of the Prize, but reserves the right at any
              time to provide a similar item as a substitute.
            </Text>
            <Text>
              BulletScout reserves the right to provide as a substitute for the
              Prize, in whole or in part, the cash equivalent value of the Prize
              (or any remaining portion of the Prize), as determined by
              BulletScout, in an amount not to exceed $15,000.00.
            </Text>
          </VStack>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              5. Winner Selection and Notification
            </Heading>
            <Text>
              Exactly one (1) winner will be selected through a random drawing
              from among all eligible cumulative entries received during the
              Entry Period. The drawing will be conducted by BulletScout or its
              representatives using the gleam.io random selection engine, and
              the winner notified, no later than seven (7) days following the
              end of the Entry Period.{" "}
            </Text>
            <Text>
              The winner will be notified via the email provided during entry
              into the competition. If the winner does not respond to
              BulletScout.com within seven (7) days of being notified, or is
              otherwise found to be ineligible, an alternate winner may be
              selected at BulletScout’s discretion.
            </Text>
            <Text>
              Within seven (7) days of being notified, the winner will be
              required to complete and return to BulletScout (a) a notarized
              Affidavit of Eligibility; (b) any documents necessary for tax
              purposes; (c) a liability/publicity release; (d) an address to
              which the prize may be shipped, and (e) any other documentation
              required by BulletScout for prize fulfillment, including but not
              limited to proof of identity and any other licenses or permits. If
              the winner does not provide the requested documents and
              information within seven (7) days of being notified, an alternate
              winner may be selected at BulletScout’s discretion.
            </Text>
          </VStack>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              6. Prize Delivery
            </Heading>
            <Text>
              All ammunition shipments and transfers will be conducted in
              accordance with applicable federal, state, and local laws
              regarding shipping and transfer, including but not limited to,
              initial transfer to an appropriately licensed Federal Firearms
              Licensee (“FFL”) prior to transfer to the winner, where required.
            </Text>
            <Text>
              A portion of the Prize (1 case) will be shipped to the winner at
              the winner’s designated address each year for eighty (80) years
              (or, where required, the winner’s designated FFL). If the winner
              wishes to change the designated address (or designated FLL) to
              which the portion of the Prize is to be shipped in a particular
              year, the winner must notify BulletScout in writing of the address
              change no later than June 4th.
            </Text>
            <Text>
              The shipment of the initial portion of the Prize will be shipped
              within thirty (30) days of the winner completing and returning the
              documents required under Paragraph 6 above. Shipments in
              subsequent years will be shipped on or about July 4th of each year
              to the winner’s address on file. Alternatively, and at
              BulletScout’s sole discretion, the entirety of the Prize (or of
              any remaining portion of the Prize) may be shipped in one
              shipment.
            </Text>
          </VStack>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              7. General Prize Terms & Conditions
            </Heading>
            <Text>
              The odds of winning will depend upon the number of valid entries
              received.
            </Text>
            <Text>
              The winner must comply with all federal, state, and local laws
              regarding the purchase, receipt, transfer, possession, and use of
              ammunition.
            </Text>
            <Text>
              If the winner is unable to legally receive ammunition in their
              state of residence, BulletScout may substitute the Prize with a
              cash equivalent, or select an alternate winner at its sole
              discretion.
            </Text>
            <Text>
              BulletScout reserves the right to disqualify any winner who does
              not meet the legal requirements to receive, accept transfer of, or
              own ammunition.
            </Text>
            <Text>
              By submitting an entry or otherwise participating in the Giveaway,
              entrants agree:
            </Text>
            <List as="ol" styleType="lower-alpha" pl={8} spacing={2}>
              <ListItem>
                To be bound by (i) these Official Giveaway Rules Terms &
                Conditions, (ii) the general Terms of Use & Privacy Policy as
                posted on the BulletScout.com website, and (iii) BulletScout’s
                decisions, which are final and binding in all matters related to
                the Giveaway.
              </ListItem>
              <ListItem>
                To release BulletScout, its affiliates, subsidiaries, officers,
                directors, principals, employees or agents, from any liability
                related to the Giveaway, including but not limited to delays in
                Prize delivery, legal restrictions, or misuse of the Prize.
              </ListItem>
              <ListItem>
                That all prizes are awarded upon the condition that BulletScout
                and its respective affiliates, subsidiaries, officers,
                directors, principals, employees or agents shall have no
                liability whatsoever and shall be held harmless for any
                injuries, losses, or damages of any kind to persons or property,
                including death, sustained, in whole or in part, directly or
                indirectly, in connection with or resulting from acceptance,
                possession or use/misuse of the Prize, or participation in this
                Giveaway or participation in any Giveaway-related activities.
              </ListItem>
              <ListItem>
                That BulletScout has neither made, nor is in any manner
                responsible or liable for, any warranty, representation or
                guarantee, expressed or implied, in fact or in law, relative to
                any prize, including but not limited to its merchantability,
                quality, mechanical condition or fitness for a particular
                purpose.
              </ListItem>
              <ListItem>
                To allow BulletScout to use their name and likeness for
                promotional purposes without additional compensation, except
                where prohibited by law.
              </ListItem>
            </List>
            <Text>
              The Prize is non-transferable and may not be sold or exchanged.
              The prize is intended for the winner’s personal use only, and is
              not to be resold.
            </Text>
            <Text>
              This Giveaway is void where prohibited or restricted by law.
            </Text>
            <Text>
              BulletScout makes no warranties, representations, endorsement, or
              guarantees, expressed or implied, in fact or in law, with respect
              to the performance or use of the Prize, including, without
              limitation, quality, merchantability, and fitness for a particular
              purpose.
            </Text>
            <Text>
              Promotional graphics depicting the Prize may differ from the
              actual Prize awarded.
            </Text>
          </VStack>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              8. Modifications & Termination
            </Heading>
            <Text>
              BulletScout reserves the right to modify, suspend, or terminate
              the Giveaway at any time for reasons including, but not limited
              to, fraud, technical failure, or legal compliance issues.
            </Text>
          </VStack>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              9. Governing Law
            </Heading>
            <Text>
              The Giveaway is governed by the laws of the United States and the
              laws of the State of Texas, without respect to conflict of law
              doctrines. Any disputes arising out of the Giveaway shall be
              resolved exclusively in the courts of the Northern District of
              Texas or Dallas County, Texas.
            </Text>
          </VStack>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              10. Responsibility For Taxes, Fees, & Other Charges
            </Heading>
            <Text>
              The winner is solely responsible for any federal, state, and/or
              local taxes, fees, or other costs associated with winning or
              receiving the Prize or its cash substitute. BulletScout may issue
              a Form 1099-MISC for the retail value of the Prize, or other tax
              documents to the winner as required by law.
            </Text>
            <Text>
              The winner shall be solely responsible for any fees related to
              transferring ownership of the Prize to the winner, including but
              not limited to FFL background check or transfer fees.
            </Text>
          </VStack>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              11. Disqualification & Fraud Prevention
            </Heading>
            <Text>
              BulletScout reserves the right to disqualify any entrant who:
            </Text>
            <List as="ol" styleType="lower-alpha" pl={8} spacing={2}>
              <ListItem>
                Uses multiple email addresses or false identities to enter the
                Giveaway.
              </ListItem>
              <ListItem>
                Engages in fraudulent activities, including bot entries or other
                attempts to manipulate the contest.
              </ListItem>
              <ListItem>
                Violates these Terms & Conditions or engages in any activity
                that, in BulletScout’s sole discretion, compromises the
                integrity of the Giveaway.
              </ListItem>
            </List>
          </VStack>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              12. Force Majeure
            </Heading>
            <Text>
              BulletScout shall not be held liable for failure to fulfill any
              obligations due to causes beyond its control, including but not
              limited to: acts of God, government regulations, natural
              disasters, supply chain disruptions, or unforeseen legal
              restrictions on the sale or distribution of ammunition.
            </Text>
          </VStack>

          <VStack spacing={4} align="start">
            <Heading as="h2" size="lg">
              13. Privacy & Data Collection
            </Heading>
            <Text>
              By entering the Giveaway, entrants consent to the collection and
              use of their personal information by BulletScout for the purposes
              of administering the contest.
            </Text>
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default GiveawayTermsAndPrivacy;
